import { useEffect, useState } from 'react';
import { Control, useController } from 'react-hook-form';

import lodash from 'lodash';

import { Option } from 'types';

import { pickMotive } from 'data/selectMotives.data';

const usePostCodeSelect = (
  defaultValue: string,
  options: Option[],
  city: string,
  control: Control,
  controlName: string,
  disabled: boolean,
  isAdditionalTheme: boolean,
  loading: boolean
) => {
  const [selectedValue, selectedValueSet] = useState<Option>();
  const { field } = useController({ control, name: controlName });

  const getStyle = () => {
    if (disabled) return pickMotive('disabled');
    if (isAdditionalTheme) return pickMotive('default');
    return pickMotive('filter');
  };

  useEffect(() => {
    if (field.value !== '' && defaultValue) {
      selectedValueSet(
        options.filter((c) => {
          if (c?.additional?.city) {
            return (
              defaultValue?.replaceAll('-', ' ') === c.value &&
              city?.toLocaleLowerCase() ===
                lodash.deburr(c.additional?.city?.toLocaleLowerCase())
            );
          }

          return defaultValue?.replaceAll('-', ' ') === c.value;
        })[0]
      );
    }
    selectedValueSet(options.filter((e) => e.value === field.value)[0]);
  }, [defaultValue, options]);

  useEffect(() => {
    if (loading) {
      options.unshift({ value: '', label: 'Loading...' });
    }
    if (options.length === 1 && options[0].value === '' && !loading) {
      options.shift();
    }
  }, [options, loading]);

  return {
    selectedValue,
    selectedValueSet,
    getStyle,
  };
};

export { usePostCodeSelect };
